import { useFetchScheduleActions } from '@/api/hooks/useFetchScheduleActions'
import { ScheduleHoldReason, type VrdhCallReason } from '@/api/types/ProviderApi'
import { ScheduleAppointmentButton } from '@/components/ScheduleAppointmentButton'
import { ScheduleCallButton } from '@/components/ScheduleCallButton'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'

const BookAppointmentCTA = () => (
	<VStack className="items-center justify-center" gap={18}>
		<Text className="max-w-56 text-center">
			Looks like you have no upcoming appointments.
		</Text>
		<ScheduleAppointmentButton />
	</VStack>
)

const VrdhCallRequiredCTA = ({ callReason }: { callReason: VrdhCallReason }) => (
	<VStack className="items-center justify-center" gap={18}>
		<Text className="max-w-xs text-center native:font-apercu-bold">
			Our Wally clinicians would like to go over your recent results before booking a new
			appointment.
		</Text>
		<ScheduleCallButton callReason={callReason} />
	</VStack>
)

const MedicalClearanceRequiredCTA = ({ callReason }: { callReason: VrdhCallReason }) => (
	<VStack className="items-center justify-center" gap={18}>
		<Text className="max-w-xs text-center native:font-apercu-bold">
			Our Wally clinicians require medical clearance from your doctor before scheduling a
			new appointment. Feel free to book a call to discuss next steps/submit your
			clearance.
		</Text>
		<ScheduleCallButton callReason={callReason} />
	</VStack>
)

const AwaitingAppointmentResultsCTA = () => (
	<VStack className="items-center justify-center" gap={18}>
		<Text className="max-w-56 text-center native:font-apercu-bold">
			We're currently analyzing the results from your last appointment before you can
			schedule your next Wally visit!
		</Text>
	</VStack>
)

export const SchedulingActions = () => {
	const { schedulingActions } = useFetchScheduleActions()

	if (
		schedulingActions?.schedulingHoldReason ===
		ScheduleHoldReason.AWAITING_MEDICAL_CLEARANCE
	) {
		return <MedicalClearanceRequiredCTA callReason={schedulingActions.vrdhCallReason} />
	}

	if (schedulingActions?.schedulingHoldReason === ScheduleHoldReason.AWAITING_RESULTS) {
		return <AwaitingAppointmentResultsCTA />
	}

	if (schedulingActions?.schedulingHoldReason === ScheduleHoldReason.VRDH_REQUIRED) {
		return <VrdhCallRequiredCTA callReason={schedulingActions.vrdhCallReason} />
	}

	if (schedulingActions?.canScheduleAppointment) {
		return <BookAppointmentCTA />
	}

	return null
}
